<template>
  <tr
    :class="{ 'boss-table-4-selected': !entryObject.entry.isRead }"
    data-test="tr-show"
  >
    <td
      class="boss-center pega-input"
      data-test="check"
      @click="entryObject.isChecked = !entryObject.isChecked; updateChecked();"
    >
      <input
        data-role="select-user"
        type="checkbox"
        class="boss-input-checkbox"
        :checked="entryObject.isChecked"
      >
    </td>
    <td
      class="boss-center boss-table-4-link-cell"
    >
      <router-link
        :to="{ name: 'entryDetail', params: { entryId: entryObject.entry.id, tabKey: 'resume' } }"
        data-test="date"
        class="boss-table-4-link"
      >
        {{ entryDate }}
        <div data-test="time">
          {{ entryTime }}
        </div>
      </router-link>
    </td>
    <td class="boss-center">
      <router-link
        :to="{ name: 'entryDetail', params: { entryId: entryObject.entry.id, tabKey: 'resume' } }"
        data-test="user-id"
        class="boss-table-4-link boss-table-4-link-has-mark"
      >
        ID:{{ entryObject.entry.user.id }}
        <span
          v-if="entryObject.entry.user.isWithdrawal"
          data-test="withdrawal"
        >（途中退会）</span>
        <span v-if="entryObject.entry.user.isDuplicatedEntries"><br><span
          v-tooltip="{ content: '別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。', trigger: 'hover' }"
          class="boss-status-label"
          data-test="duplicate"
        >重複応募</span></span>
        <div
          data-test="member-name"
          class="pega-pre-wrap"
          v-text="memberName"
        />
        <div data-test="member-summary">
          {{ memberSummary }}
        </div>
      </router-link>
    </td>
    <td
      class="is-boss-only-pc"
    >
      <router-link
        :to="{ name: 'entryDetail', params: { entryId: entryObject.entry.id, tabKey: 'resume' } }"
        data-test="job-id"
        class="boss-table-4-link"
      >
        求人ID:{{ entryObject.entry.job.id }}
        <div data-test="job-name">
          {{ jobName }}
        </div>
      </router-link>
    </td>
    <td class="boss-center">
      <div class="boss-layout boss-layout-vertical">
        <div>
          <div class="boss-layout boss-layout-gap-small">
            <div
              v-if="entryObject.entry.approachingStatus.scout.isSend"
            >
              <span
                v-tooltip="{ content:entryObject.entry.approachingStatus.scout.isEffective ? '' : expiredMessage }"
                class="pega-scout-label"
                :disabled="!entryObject.entry.approachingStatus.scout.isEffective"
                data-test="scout-label"
              >スカウト</span>
            </div>
            <div
              v-if="entryObject.entry.approachingStatus.offerDm.isSend"
            >
              <img
                v-tooltip="{ content:entryObject.entry.approachingStatus.offerDm.isEffective ? 'オファーDM' : expiredMessage }"
                :class="{ 'boss-icon-end': !entryObject.entry.approachingStatus.offerDm.isEffective }"
                src="@/assets/images/icon-offer-dm.svg"
                data-test="dm-icon"
              >
            </div>
          </div>
        </div>
        <div>
          <div class="boss-layout boss-layout-vertical boss-layout-no-gap">
            <div
              v-for="sendingFavor in entryObject.entry.approachingStatus.specialFavors"
              :key="sendingFavor.id"
            >
              <span
                v-tooltip="{ content: getSpecialFavorTooltip(sendingFavor)}"
                :data-test="'special-favor-' + sendingFavor.id"
                :class="{ 'boss-bonus-end': !sendingFavor.isEffective }"
                class="boss-bonus-check-text boss-bonus-check-text-gap-small boss-check-true"
              >{{ sendingFavor.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </td>
    <message-icon-information
      :message="entryObject.entry.message"
      :entry-id="entryObject.entry.id"
      :is-entry-message-reservation-reserved="entryObject.entry.isEntryMessageReservationReserved"
    />
    <template v-for="(displayItem) in displayItems">
      <td
        v-if="displayItem === 'phase'"
        :key="'outline-' + displayItem"
        class="boss-center is-boss-only-pc"
        data-test="phase"
      >
        <select
          v-model="entryObject.entry.currentSelection.phaseId"
          class="boss-input-select js-check-default"
          data-default
          data-test="selection-phase"
          @change="updateSelectionPhase"
        >
          <option
            v-for="(selectionPhase ,i) in phases"
            :key="i"
            :value="selectionPhase.id"
          >
            {{ selectionPhase.name }}
          </option>
        </select>
      </td>
      <td
        v-if="displayItem === 'status'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc"
        data-test="status"
      >
        <select
          v-model="entryObject.entry.currentSelection.statusId"
          class="boss-input-select js-check-default"
          data-default
          data-test="selection-status"
          @change="updateSelectionStatus"
        >
          <option :value="null">
            −
          </option>
          <option
            v-for="(selectionStatus ,i) in allStatuses"
            :key="i"
            :value="selectionStatus.id"
          >
            {{ selectionStatus.name }}
          </option>
        </select>
      </td>
      <td
        v-if="displayItem === 'remarks'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc boss-table-cell-has-textarea pega-position-inherit"
        data-test="remarks"
      >
        <textarea
          v-model="entryObject.entry.remarks"
          class="boss-textarea-in-table"
          rows="5"
          data-test="text-remarks"
          @change="updateRemarks"
        />
      </td>
      <td
        v-if="displayItem === 'responsible_staffs'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc"
        data-test="responsible-staffs"
      >
        <select
          v-model.number="entryObject.entry.responsibleStaffId"
          class="boss-input-select js-check-default"
          data-test="select-responsible-staffs"
          @change="updateResponsibleStaff"
        >
          <option :value="null">
            −
          </option>
          <option
            v-for="staff in responsibles"
            :key="staff.id"
            :value="staff.id"
          >
            {{ staff.name }}
          </option>
        </select>
      </td>
      <td
        v-if="displayItem === 'evaluation'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc"
        data-test="evaluation-name"
      >
        {{ evaluationName }}
      </td>
      <td
        v-if="displayItem === 'comment'"
        :key="'outline-' + displayItem"
        class="is-boss-only-pc pega-pre-wrap"
        data-test="evaluation-comment"
        v-text="entryObject.entry.currentSelection.evaluationComment || '−'"
      />

      <td
        v-if="displayItem === 'selection_date'"
        :key="'outline-' + displayItem"
        data-test="selection-date"
        class="is-boss-only-pc pega-pre-wrap text-center"
        :class="{ 'notice-background' : !entryObject.entry.recentSelection }"
      >
        <router-link
          :to="{ name: 'entryDetail', params: { entryId: entryObject.entry.id, tabKey: 'selection' } }"
          data-test="selection-date-router"
          class="boss-table-4-link"
        >
          <span
            v-if="entryObject.entry.recentSelection"
            class="pega-reminded-label"
          >
            <div
              data-test="selection-date-day-time"
              :class="{'line-through display-inline': isReminded }"
            >
              <div
                data-test="selection-date-day"
                v-text="recentSelectionDate"
              />
              <span
                data-test="selection-date-time"
                v-text="recentSelectionTime"
              />
            </div>
            <div
              v-if="isReminded"
              data-test="reminded"
              class="text-nowrap"
              v-text="'リマインド済'"
            />
          </span>
          <div
            v-else
            data-test="selection-date-no-setting"
            v-text="'未設定'"
          />
          <button
            class="boss-button boss-button-compact"
            data-test="selection-date-button"
            @click="goToEntryDetailSelection()"
          >
            <span class="boss-button-text">{{ recentSelectionButtonText }}</span>
          </button>
          <div
            v-if="showRemindIcon"
            data-test="selection-date-remind-icon"
            class="pega-selection-bell-icon"
          >
            <span class="boss-icon boss-icon-bell-solid" />
          </div>
        </router-link>
      </td>
    </template>
  </tr>
</template>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import * as parse from '@/lib/parse'
import { mapGetters } from 'vuex'
import cartInAnimation from '@/lib/cartInAnimation'
import MessageIconInformation from '@/components/atoms/MessageIconInformation'

export default {
  components: {
    MessageIconInformation
  },
  props: {
    entryObject: {
      type: Object,
      required: true
    },
    displayTarget: {
      type: Array,
      default: () => []
    },
    displayItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('settings', [
      'phases',
      'allStatuses',
      'responsibles',
      'fixedStatuses'
    ]),
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    expiredMessage: () => '期限切れのため、薄色で表示しています。',
    entryDate () {
      return dayjs(_.get(this.entryObject, 'entry.entryDate')).format('YY/MM/DD')
    },
    entryTime () {
      return dayjs(_.get(this.entryObject, 'entry.entryDate')).format('HH:mm')
    },
    memberSummary () {
      const summaries = [_.get(this.entryObject, 'entry.user.prefecture.name'), this.parseAge(_.get(this.entryObject, 'entry.user.birthday')) + '歳', _.get(this.entryObject, 'entry.user.gender.name')]
      return _(summaries).compact().join(' ')
    },
    memberName () {
      return this.entryObject.entry.user.lastName + this.entryObject.entry.user.firstName
    },
    evaluationName () {
      return _.get(this.entryObject.entry.currentSelection.evaluation, 'name', '') || '−'
    },
    recentSelectionDate () {
      return dayjs(_.get(this.entryObject, 'entry.recentSelection.selectionDateTime')).format('YY/MM/DD')
    },
    recentSelectionTime () {
      return dayjs(_.get(this.entryObject, 'entry.recentSelection.selectionDateTime')).format('HH:mm')
    },
    myPageStatus: () => 2,
    RemindStatus: () => 3,
    recentSelectionIsRemind () {
      return _.get(this.entryObject, 'entry.recentSelection.remindStatus') === this.RemindStatus
    },
    isReminded () {
      return [this.myPageStatus, this.RemindStatus].includes(_.get(this.entryObject, 'entry.recentSelection.remindStatus')) &&
        dayjs().isAfter(`${dayjs(_.get(this.entryObject, 'entry.recentSelection.selectionDateTime')).subtract(1, 'days').format('YYYY-MM-DD')} 09:30`, 'minute')
    },
    jobName () {
      if (this.entryObject.entry.job.name.length > 20) {
        return this.entryObject.entry.job.name.match(/^.{0,20}/) + '...'
      } else {
        return this.entryObject.entry.job.name
      }
    },
    recentSelectionButtonText () {
      return _.get(this.entryObject, 'entry.recentSelection') ? '更新' : '設定'
    },
    showRemindIcon () {
      return _.get(this.entryObject, 'entry.recentSelection') && this.recentSelectionIsRemind && !this.isReminded
    }
  },
  methods: {
    updateChecked () {
      this.$emit('update-checked', { id: this.entryObject.entry.id, isChecked: this.entryObject.isChecked })
    },
    parseAge (birthdateString) {
      return parse.age(birthdateString)
    },
    updateRemarks () {
      this.$http.secured.put('/entry/view/entries/remarks',
        {
          entryIds: [this.entryObject.entry.id],
          remarks: this.entryObject.entry.remarks
        }
      ).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: '備考を更新しました。' })
      })
    },
    updateSelectionPhase () {
      this.$http.secured.put('/entry/view/entries/phases',
        {
          entryIds: [this.entryObject.entry.id],
          itemId: this.entryObject.entry.currentSelection.phaseId
        }
      ).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: '選考フェーズを更新しました。' })
        this.$emit('update-selections', this.entryObject.entry.id)
      })
    },
    updateSelectionStatus () {
      this.$http.secured.put('/entry/view/entries/phase_statuses',
        {
          entryIds: [this.entryObject.entry.id],
          itemId: this.entryObject.entry.currentSelection.statusId
        }
      ).then(response => {
        const targetElementId = _.includes(this.fixedStatuses.map(status => status.id), this.entryObject.entry.currentSelection.statusId)
          ? `#display-target-${this.entryObject.entry.currentSelection.statusId}` : ''
        this.$toasted.global.successRightTopSingleton(
          {
            message: `選考ステータスを更新しました。${targetElementId ? `<br>画面右上の「${this.getFixedStatusesName(this.entryObject.entry.currentSelection.statusId)}」ボタンをONにした場合のみ表示されます。` : ''}`
          }
        )
        targetElementId && cartInAnimation.start(_.includes(this.displayTarget, this.entryObject.entry.currentSelection.statusId) ? this.$el : '#entry-entries', targetElementId)
        this.$emit('update-selections', this.entryObject.entry.id)
      })
    },
    updateResponsibleStaff () {
      this.$http.secured.put('/entry/view/entries/responsible_staffs', {
        entryIds: [this.entryObject.entry.id], itemId: this.entryObject.entry.responsibleStaffId
      }).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: '人事担当を更新しました。' })
      })
    },
    goToEntryDetailSelection () {
      // 画面遷移
      this.$router.push({ name: 'entryDetail', params: { entryId: this.entryObject.entry.id, tabKey: 'selection' } })
    },
    getFixedStatusesName (statusId) {
      return this.fixedStatuses.find(status => _.isEqual(status.id, statusId)).name
    },
    getSpecialFavorTooltip (specialFavor) {
      return specialFavor.isEffective ? this.specialFavorBy(specialFavor.id).description : this.expiredMessage
    }
  }
}
</script>
